const addPageAttributeToTiles = (html, currentPage) => {
    if (html.inited) {
        return false;
    }
    var productTiles = html.querySelectorAll('[is="m-product-tile"]');

    for (var productTile of productTiles) {
        productTile.dataset.currentPage = currentPage;
    }

    return html;
};

module.exports = {
    addPageAttributeToTiles: addPageAttributeToTiles
};
